import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePregnancies = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["pregnancies", patientId, tenantVal],
    queryFn: async () => {
      const axios = createAxiosInstance();
      const response = await axios.get(
        `${tenantVal}/pregnancy/getbypatientid/${patientId}`
      );
      return response.data?.data ?? response.data;
    },
    enabled: !!patientId && !!tenantVal,
  });
};
